import api from './api';
import { logout } from '../store/slices/authSlice';

export const setupInterceptors = (store) => {
  // Request interceptor to add auth token
  api.interceptors.request.use(
    (config) => {
      const state = store.getState();
      const token = state.auth.userToken;
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  // Response interceptor to handle auth errors
  api.interceptors.response.use(
    (response) => response,
    async (error) => {
      if (error.response?.status === 401) {
        // Token expired or invalid, logout user
        store.dispatch(logout());
        window.location.href = '/login';
      }

      return Promise.reject(error);
    }
  );
};